module.exports = __webpack_public_path__ + "static/media/spin-bg.f8aad3c6.png";